export default "__VITE_PUBLIC_ASSET__8a8d29b8__"